import {useRouteMatch, Switch, Route} from 'react-router-dom';
import {EBooks} from './e-books';
import React, {FC} from 'react';

export const EbooksRoute: FC = React.memo(() => {
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={match.path}>
        <EBooks />
      </Route>
    </Switch>
  );
});
